export enum MixedContentPageType {
  COLOR_FAMILIES = 'page___color_family',
  FAVORITE_COLORS = 'page___favorite_colors',
  COLOR_COLLECTION = 'page___color_collection',
  COLOR_DETAILS = 'page___color_details',
  PRODUCT_DETAILS = 'page___product_details',
  PRODUCT_DETAILS_OLD = 'page___non_transactable_pdp',
  PRODUCT_LIST = 'page___non_transactable_plp',
  COLORS = 'page___color_list',
}
